import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ConfirmedValidator } from '../../confirmed.validator';
import { UtilitaService } from '../../services/utilita.service';


@Component({
  selector: 'app-uguale-dipartimento',
  templateUrl: './uguale-dipartimento.component.html',
  styleUrls: ['./uguale-dipartimento.component.css']
})
export class UgualeDipartimentoComponent implements OnInit {
  lstDipartimenti: any;
  frmInserimento!: FormGroup;
  objdettaglio: any;

  txtCognome: string = '';
  txtNome: string = '';

  sPersona: string = '';

  constructor(private fb: FormBuilder, public dialogRef: MatDialogRef<UgualeDipartimentoComponent>,
    private snackBar: MatSnackBar,
    private srvUtilita: UtilitaService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit(): void {
   // console.log('idrichiesta modale',this.data.idRichiesta);
   // console.log('iddipartimento modale', this.data.idDipartimento)

    this.frmInserimento = this.fb.group({
      idUtentiProfilo: [null],
      idDipartimento: [null],
      Cognome: [null],
      Nome: [null]
    })

    if (this.data.idDipartimento) { }
    if (this.data.idutente) { }
    if (this.data.idRichiesta) { }
   // this.getUtentiDipartimento(this.data.idDipartimento);
  }

  getUtentiDipartimento(idDipartimento: number, sNome:string, sCognome:string) {
    this.srvUtilita.getLista('Utenti/GetUtentiProfiloLista?iIdDipartimentoUtenteLoggato=' + idDipartimento
      + '&sNome=' + sNome+'&sCognome='+sCognome).subscribe((res: any) => {
        this.lstDipartimenti = res;

    // console.log("this.lstDipartimenti:", res);
    }, (err: any) => {
    })
  }
  /*
  getProfiloUtente(sCognome: string) {
    this.srvUtilita.getLista('Utenti/GetUtentiModale?sCognome=' + this.txtCognome).subscribe((res: any) => {
      this.objdettaglio = res
      console.log('obj', this.objdettaglio)
    })
  }
  */
  btnCerca() {
   
  
    this.getUtentiDipartimento(this.data.idDipartimento, this.txtNome, this.txtCognome);
  }
  showMessage(message: string, action: string) {
    this.snackBar.open(message, action, { duration: 3000 })
  }
  btnSalva() {   
    let objInserimento: any
    objInserimento = this.frmInserimento.value

    const obj =
    {
      idUtenteProfilo: this.frmInserimento.value.idUtentiProfilo, 
      idRichiestaProfilo: this.data.idRichiesta
    }
    this.srvUtilita.postObj('Clienti/AssociaNominativoAllaRichiesta', obj).subscribe((res: any) => {
      this.showMessage('Operazione avvenuta correttamente.', 'OK')
      this.dialogRef.close()
      
       
    }, (err: any) => {
      this.showMessage('Errore: i dati non sono stati inseriti in modo corretto.', 'OK')
     // console.log(err.error.Message, 'ERRORE');
    })

  }

  btnEsci() {
    this.dialogRef.close();
  }
  
}
